/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Request_BtnInputs */



/**
* | output |
* | --- |
* | "Request signature" |
*
* @param {Nda_Request_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_request_btn = /** @type {((inputs?: Nda_Request_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Request_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demander la signature")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solicitar la firma")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Solicitar a assinatura")
	if (locale === "it") return /** @type {LocalizedString} */ ("Richiedi la firma")
	return /** @type {LocalizedString} */ ("Request signature")
});